export const themeColors = {
  darkText: '#2b2b2b',
  themeYellow: '#f1c80f',
  themeLightBlue: '#00aae1',
  themeDarkBlue: '#333f49',
  surface: '#efefef',
  lightGray: '#e9ecf6',
  lightText: '#f5f5f5',
}
